import { AttentionOptions, batchDetectLandmarks } from './detect-landmarks';
import { parseImages } from './image-parser';
import { ImageWithLandMark } from './image-with-landmark';
import { parseJson, sendRequest } from './request-utils';

export interface ImageData {
  images: HTMLImageElement[] | File[];
  fps?: number;
  videoTime?: number;
}

export interface AttentionResult {
  level: number;
  message: string;
}

export async function getAttentionLevel(
  url: string,
  imageData: ImageData,
  options?: AttentionOptions
): Promise<AttentionResult> {
  const images: HTMLImageElement[] = await parseImages(imageData.images);
  const imageWithLandMarks: ImageWithLandMark[] = await batchDetectLandmarks(
    images,
    options
  );
  const jsonParsed = await parseJson(imageWithLandMarks, imageData);
  const results = await sendRequest(url, jsonParsed);

  return results;
}
